import { render, staticRenderFns } from "./AddClientAgencyZamfara.vue?vue&type=template&id=3acc804e&"
import script from "./AddClientAgencyZamfara.vue?vue&type=script&lang=js&"
export * from "./AddClientAgencyZamfara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports